import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { DictRef3 } from "./DictRef/DictRef3";

export const makeDictRefLabel = (data: MakeLabelParams) => (
  <DictRef3 params={data} />
);
